import React, { createContext, useContext, ReactNode, useRef } from "react";
import { StoreApi } from "zustand";
import createComponentStore, { ComponentState } from "store/component-store";

const ComponentContext = createContext<StoreApi<ComponentState> | undefined>(undefined);

export const useComponentStoreContext = () => {
  const context = useContext(ComponentContext);
  if (!context) {
    return null
  }
  return context;
};

interface ComponentProviderProps {
  children: ReactNode;
  initialState?: Partial<ComponentState>;
}

export const ComponentProvider = ({ children, initialState }: ComponentProviderProps) => {
  const storeRef = useRef<StoreApi<ComponentState>>();

  if (!storeRef.current) {
    storeRef.current = createComponentStore(initialState);
  }

  return <ComponentContext.Provider value={storeRef.current}>{children}</ComponentContext.Provider>;
};
